'use client';
import React from 'react';

const BASE = 'https://cullertons-b4f8396.public.builtwithrocket.new';

const testimonials = [
{
  tag: 'PROFESSIONAL SERVICE',
  quote: 'We would like to thank Mark, Greig and Team Cullerton for their professional service when we were selling our house in Blackhall. The team were always available when we wanted advice. We would definitely recommend them.',
  name: 'Mark & Olga Stewart',
  delay: 'delay-100'
},
{
  tag: 'MARKET KNOWLEDGE',
  quote: "Mark sold our home in EH4 and I'm so glad we went with Cullerton's. The personal attention and market knowledge made all the difference \u2014 we felt looked after from start to finish.",
  name: 'Jennifer Mackay',
  delay: 'delay-200'
},
{
  tag: "MARK\'S ADVICE IS WHAT WE NEEDED",
  quote: "After 30 years in Edinburgh property, Mark's advice was exactly what we needed. He knew what buyers in our area were looking for and priced our home perfectly. Sold in under a fortnight.",
  name: 'David & Fiona Reid',
  delay: 'delay-300'
}];


export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-32 bg-forest">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Mark Cullerton bio */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center mb-20 md:mb-28">
          <div className="reveal">
            <span className="text-[11px] uppercase tracking-[0.2em] text-gold font-semibold block mb-4">Your Local Expert</span>
            <h2
              className="font-serif text-cream leading-[0.92] tracking-tight mb-6"
              style={{ fontSize: 'clamp(2.4rem, 4.5vw, 4rem)' }}>Stephen Mackenzie


            </h2>
            <div className="space-y-4 text-cream/65 text-base leading-relaxed font-light">
              <p>Since entering Edinburgh’s property market in 1999, Stephen has built extensive expertise across sales, development, new-build projects, and property management.

              </p>
              <p>Renowned for exceptional client service, he prioritises clear communication, ensuring a seamless sales process. He also specialises in property searches for buying clients, offering expert guidance and a steady hand through selection and negotiation.

              </p>
              <p>Stephen lives in Edinburgh’s New Town with his wife, Katherine, and their daughter, embracing city life. A keen golfer, he plays in East Lothian and St Andrews, while walks with his retriever, Mabel, take him to Inverleith Park and The Pentlands. His ideal coffee moment is spent with the dog at his feet and a freshly brewed espresso in hand.

              </p>
            </div>
            <div className="mt-6 space-y-1 text-gold text-sm font-light">
              <p>
                <a href="mailto:mark@cullertonsproperty.co.uk" className="hover:text-gold transition-colors font-normal">stephen@cullertonsproperty.co.uk

                </a>
              </p>
              <p>
                <a href="tel:07931378008" className="hover:text-gold transition-colors font-normal text-base">07963 052774

                </a>
              </p>
            </div>
            <div className="flex flex-wrap gap-6 mt-8">
              <div className="border-l-2 border-sage pl-4">
                <span className="font-serif text-2xl text-cream block">27+</span>
                <span className="text-[11px] uppercase tracking-widest text-cream/45 font-medium">Years Experience</span>
              </div>
              <div className="border-l-2 border-sage pl-4">
                <span className="font-serif text-2xl text-cream block">Award</span>
                <span className="text-[11px] uppercase tracking-widest text-cream/45 font-medium">Winning Service</span>
              </div>
              <div className="border-l-2 border-sage pl-4">
                <span className="font-serif text-2xl text-cream block">EH3</span>
                <span className="text-[11px] uppercase tracking-widest text-cream/45 font-medium">Home Postcode</span>
              </div>
            </div>
          </div>

          <div className="reveal delay-200 relative">
            <div className="rounded-4xl overflow-hidden aspect-[4/5] photo-hover border border-cream/10">
              <div className="relative" style={{ width: '100%', height: '100%' }}>
                <img
                  alt="Stephen Mackenzie, professional headshot"
                  src="/assets/images/Stephen_Mackenzie-1776859711687.jpg"
                  className="object-cover bg-gray-200"
                  style={{ position: 'absolute', height: '100%', width: '100%', left: 0, top: 0, objectFit: 'cover' }} />

              </div>
            </div>
          </div>
        </div>

        {/* Testimonials */}
        <div>
          <div className="mb-10 reveal">
            <span className="text-[11px] uppercase tracking-[0.2em] text-[#CFB786] font-semibold block mb-3">Feedback</span>
            <h3 className="font-serif text-cream text-3xl md:text-4xl italic">from New Town clients</h3>
          </div>
          <div className="spotlight-group grid grid-cols-1 md:grid-cols-3 gap-5">
            {testimonials?.map((t, i) =>
            <div
              key={i}
              className={`spotlight-card rounded-3xl border border-cream/10 p-7 flex flex-col justify-between min-h-[260px] bg-cream/5 reveal ${t?.delay}`}>

                <div className="relative z-10">
                  <span className="text-[11px] uppercase tracking-[0.2em] text-[#CFB786] font-semibold block mb-4">{t?.tag}</span>
                  <p className="text-cream/70 font-serif italic text-sm leading-relaxed">&ldquo;{t?.quote}&rdquo;</p>
                </div>
                <div className="flex items-center gap-3 mt-6 relative z-10">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-full border border-[#CFB786]/40">
                    <img src="/assets/images/Logo_C_only-1776860259620.png" alt="Cullerton's C logo" className="w-7 h-7 object-contain" />
                  </div>
                  <div>
                    <span className="block text-sm font-semibold" style={{ color: '#CFB786' }}>{t?.name}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

}